import React from 'react';
import { motion } from 'framer-motion';
import { ToolCard } from './ToolCard';
import { CategoryNav } from './CategoryNav';
import { useTools } from '../hooks/useTools';
interface NewToolsSectionProps {
  activeCategory: string;
  setActiveCategory: (category: string) => void;
}
export function NewToolsSection({
  activeCategory,
  setActiveCategory
}: NewToolsSectionProps) {
  const {
    tools,
    loading,
    toolBelongsToCategory
  } = useTools();
  const filteredTools = activeCategory === 'all' ? tools : tools.filter(tool => toolBelongsToCategory(tool, activeCategory));
  return <section className="py-16 px-4 max-w-7xl mx-auto" data-id="element-336">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4" data-id="element-337">
        <div data-id="element-338">
          <h2 className="text-3xl md:text-4xl text-white mb-3 font-subtitle" data-id="element-339">
            More AI Tools
          </h2>
          <p className="text-gray-400 text-sm max-w-xl" data-id="element-340">
            Discover the latest AI innovations across every category. Updated
            daily.
          </p>
        </div>
      </div>

      <CategoryNav activeCategory={activeCategory} setActiveCategory={setActiveCategory} data-id="element-341" />

      {loading ? <div className="text-center py-20" data-id="element-342">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-cyan-500 border-t-transparent" data-id="element-343"></div>
          <p className="text-gray-400 mt-4" data-id="element-344">Loading tools...</p>
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-8" data-id="element-345">
          {filteredTools.map((tool, index) => <motion.div key={tool.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.05
      }} className="h-full" data-id="element-346">
              <ToolCard tool={tool} data-id="element-347" />
            </motion.div>)}
        </div>}

      {!loading && filteredTools.length === 0 && <div className="text-center py-20 text-gray-500" data-id="element-348">
          No tools found in this category yet.
        </div>}
    </section>;
}